/**
 * Main JavaScript Entry Point
 * Lexprint Theme
 */

import './accordion';
import './carrossel-imagens';
import './depoimentos-carousel';
import './dialog';
import './embla-carousel';
import './faq-accordion';
import './parceiros-carousel';

/**
 * Mobile Menu Toggle
 */
document.addEventListener('DOMContentLoaded', () => {
  const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (mobileMenuToggle && mobileMenu) {
    mobileMenuToggle.addEventListener('click', () => {
      const isExpanded = mobileMenuToggle.getAttribute('aria-expanded') === 'true';
      
      // Toggle aria-expanded
      mobileMenuToggle.setAttribute('aria-expanded', (!isExpanded).toString());
      
      // Toggle menu visibility
      mobileMenu.classList.toggle('hidden');
      
      // Toggle hamburger animation
      const spans = mobileMenuToggle.querySelectorAll('span');
      if (spans.length === 3) {
        if (isExpanded) {
          // Reset to hamburger
          spans[0].style.transform = 'rotate(0) translateY(0)';
          spans[1].style.opacity = '1';
          spans[2].style.transform = 'rotate(0) translateY(0)';
        } else {
          // Transform to X
          spans[0].style.transform = 'rotate(45deg) translateY(8px)';
          spans[1].style.opacity = '0';
          spans[2].style.transform = 'rotate(-45deg) translateY(-8px)';
        }
      }
    });
  }
});

/**
 * Sticky Header on Scroll
 */
window.addEventListener('scroll', () => {
  const header = document.querySelector('header');
  
  if (header) {
    if (window.scrollY > 100) {
      header.classList.add('shadow-lg');
    } else {
      header.classList.remove('shadow-lg');
    }
  }
});

/**
 * Smooth Scroll for Anchor Links
 */
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');
    
    // Skip if href is just "#"
    if (href === '#') return;
    
    const targetId = href.substring(1);
    const target = document.getElementById(targetId);
    
    if (target) {
      e.preventDefault();
      const headerHeight = document.querySelector('header')?.offsetHeight || 0;
      const targetPosition = target.offsetTop - headerHeight;
      
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    }
  });
});

/**
 * Intersection Observer for Fade-in Animations
 */
const observerOptions = {
  root: null,
  rootMargin: '0px',
  threshold: 0.1
};

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('animate-fade-in');
      observer.unobserve(entry.target);
    }
  });
}, observerOptions);

// Observe elements with data-animate attribute
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-animate="fade-in"]').forEach(el => {
    observer.observe(el);
  });
});

/**
 * Back to Top Button
 */
const createBackToTopButton = () => {
  const button = document.createElement('button');
  button.innerHTML = `
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"/>
    </svg>
  `;
  button.className = 'fixed bottom-8 right-8 z-40 w-12 h-12 flex items-center justify-center bg-custom-1 text-white rounded-full shadow-lg hover:bg-custom-2 transition-all duration-300 opacity-0 pointer-events-none';
  button.setAttribute('aria-label', 'Voltar ao topo');
  
  document.body.appendChild(button);
  
  window.addEventListener('scroll', () => {
    if (window.scrollY > 500) {
      button.classList.remove('opacity-0', 'pointer-events-none');
    } else {
      button.classList.add('opacity-0', 'pointer-events-none');
    }
  });
  
  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
};

// Initialize back to top button
if (document.body) {
  createBackToTopButton();
}

/**
 * Image Lazy Loading Enhancement
 */
if ('loading' in HTMLImageElement.prototype) {
  // Browser supports native lazy loading
  document.querySelectorAll('img[data-src]').forEach(img => {
    img.setAttribute('src', img.getAttribute('data-src') || '');
    img.removeAttribute('data-src');
  });
} else {
  // Fallback for older browsers
  const imageObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const img = entry.target as HTMLImageElement;
        const dataSrc = img.getAttribute('data-src');
        if (dataSrc) {
          img.src = dataSrc;
          img.removeAttribute('data-src');
        }
        imageObserver.unobserve(img);
      }
    });
  });
  
  document.querySelectorAll('img[data-src]').forEach(img => {
    imageObserver.observe(img);
  });
}

/**
 * Form Validation Enhancement
 */
document.querySelectorAll('form').forEach(form => {
  form.addEventListener('submit', function(e) {
    const requiredFields = form.querySelectorAll('[required]');
    let isValid = true;
    
    requiredFields.forEach(field => {
      const input = field as HTMLInputElement;
      if (!input.value.trim()) {
        isValid = false;
        input.classList.add('border-red', 'border-2');
        
        // Remove error styling after user starts typing
        input.addEventListener('input', () => {
          input.classList.remove('border-red', 'border-2');
        }, { once: true });
      }
    });
    
    if (!isValid) {
      e.preventDefault();
      const firstInvalid = form.querySelector('.border-red');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });
});

/**
 * Console Log - Theme Info
 */
console.log(
  '%cLexprint Theme',
  'color: #6b21a8; font-size: 24px; font-weight: bold;'
);
console.log(
  '%cDesenvolvido com TailwindCSS v4 + TypeScript + Vite',
  'color: #1a2332; font-size: 14px;'
);
